import { render } from "./preview-canvas.vue?vue&type=template&id=ade369ae&ts=true"
import script from "./preview-canvas.vue?vue&type=script&lang=ts"
export * from "./preview-canvas.vue?vue&type=script&lang=ts"

import "./preview-canvas.vue?vue&type=style&index=0&id=ade369ae&lang=css"
/* custom blocks */
import block0 from "../common/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Ftinyibp%2Ftinyibp%2Fsrc%2Fcomponents%2Fpreview-canvas.vue&global=true"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/runner/work/tinyibp/tinyibp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__